import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Save() {
  const navigate = useNavigate();

  return (
    <>
      <div className="px-3 pt-28">
        <div className="flex justify-between py-3">
          <p className="font-bold text-xl ">
            <ArrowBackIcon onClick={() => navigate("/subscription")} />
            &nbsp;&nbsp;&nbsp; Subscription to Save
          </p>
          <ShoppingBasketIcon />
        </div>
        <div className="border py-2  px-3 rounded-lg bg-gray-100">
          <p className="">
            Add items to your Subscription & save upto 10% on your daily user
          </p>
        </div>
        <div className="py-2 pt-4">
          <p className="text-blue-500 text-left text-xl">% Cashback</p>
        </div>
        <Divider />
        {[
          {
            title:
              "https://m.media-amazon.com/images/I/81pPi3qNECL._AC_SR350,526_FMwebp_QL65_.jpg",
          },
          {
            title:
              "https://m.media-amazon.com/images/I/81-Ka2xryqL._AC_SR350,526_FMwebp_QL65_.jpg",
          },
          {
            title:
              "https://m.media-amazon.com/images/I/81pPi3qNECL._AC_SR350,526_FMwebp_QL65_.jpg",
          },
          {
            title:
              "https://m.media-amazon.com/images/I/81-Ka2xryqL._AC_SR350,526_FMwebp_QL65_.jpg",
          },
        ].map((item) => {
          return (
            <>
              <div
                className="flex justify-center px-5 p-2 bg-white rounded-lg "
                onClick={() => navigate("/plan")}
              >
                <div className="flex-col justify-center w-1/3">
                  <img src={item.title} alt="" />
                </div>
                <div className="flex-col gap-5 w-2/3">
                  <p className="pt-6">Delivered on Mar 10</p>
                  <p className="">
                    ₹ 61 <span>₹ 91.00 OFF</span>
                  </p>
                  <div className="px-3 py-2">
                    <p className="border  border-green-400 bg-green-300 rounded-lg">
                      Subscribe to save 8%
                    </p>
                  </div>
                </div>
                <CalendarMonthOutlinedIcon onClick={() => navigate("/plan")} className=" text-blue-600" />
              </div>
            </>
          );
        })}
      </div>
    </>
  );
}
